import { createFileRoute } from '@tanstack/react-router'
import { ProfileSettingsPage } from '../components/auth-pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/settings/profile')({
  head: () => noIndexRouteHead('settingsProfile', 'en'),
  component: ProfileSettingsPage,
})
